import React from 'react';
import { motion } from 'framer-motion';
import { Users, Target, Shield } from 'lucide-react';

const AboutApproach = () => {
  const highlights = [
    {
      id: 1,
      icon: Users,
      title: "Who We Serve",
      items: [
        "Individuals managing personal or professional documentation",
        "Businesses handling documentation-intensive operations",
        "Organizations seeking dependable administrative support"
      ]
    },
    {
      id: 2,
      icon: Target,
      title: "Our Approach",
      description: "We believe strong documentation is the foundation of trust. Our approach combines attention to detail, clear processes, and human expertise to deliver consistent, reliable outcomes while maintaining confidentiality and professionalism."
    },
    {
      id: 3,
      icon: Shield,
      title: "Our Commitment",
      description: "Validate Systems is committed to transparency, accuracy, and dependable service. By focusing on documentation first and verification where necessary, we help our clients operate with greater confidence and fewer administrative challenges."
    }
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {highlights.map((highlight, index) => {
            const IconComponent = highlight.icon;
            return (
              <motion.div
                key={highlight.id}
                className="text-left"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="flex items-start mb-6">
                  <div className="w-16 h-16 bg-acBlack rounded-full flex items-center justify-center flex-shrink-0">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                </div>

                <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
                  {highlight.title}
                </h3>
                
                {highlight.items ? (
                  <ul className="space-y-2">
                    {highlight.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="text-gray-600 leading-relaxed text-sm flex items-start">
                        <span className="mr-2 text-acYellow font-bold">•</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-gray-600 leading-relaxed">
                    {highlight.description}
                  </p>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutApproach;
